window.addClassUnlessExist = function addClassUnlessExist(element, className) {
  if(!element.hasClass(className)) { element.addClass(className) }
}
